import React from "react";
import ReactDOM from "react-dom/client";
import { AuthProvider } from "context/AuthContext";
import { FortuneProvider } from "context/FortuneContext";
import { FortunePremiumProvider } from "context/FortunePremiumContext";
import { PointsAndBalanceProvider } from "context/PointsAndBalance";
import { TopUpsAndPaymentsProvider } from "context/TopUpsAndPayments";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <FortuneProvider>
        <FortunePremiumProvider>
          <PointsAndBalanceProvider>
            <TopUpsAndPaymentsProvider>
              <App />
            </TopUpsAndPaymentsProvider>
          </PointsAndBalanceProvider>
        </FortunePremiumProvider>
      </FortuneProvider>
    </AuthProvider>
  </React.StrictMode>,
);
